<template>
  <div class="carry-out">
    <Row class="detail-header">
      <span>执行</span>
      <ButtonGroup size="small" class="lawsuit-btn">
        <Button :type="tabActive === 'executionFiling' ? 'primary' : 'default'" @click="tabActive = 'executionFiling'">执行立案</Button>
        <!-- <Button :disabled="disabledCtrl" :type="tabActive === 'acceptance' ? 'primary' : 'default'" @click="tabActive = 'acceptance'">受理</Button> -->
        <Button :type="tabActive === 'acceptance' ? 'primary' : 'default'" @click="tabActive = 'acceptance'">受理</Button>
      </ButtonGroup>
      <!-- <Row v-if="isCarryOut" class="add-btn">
        <Button v-if="editState" type="primary" @click="openAdd">新建执行</Button>
      </Row> -->
    </Row>
    <!-- <Row v-if="showOld" class="carry-out-list">
      <Row v-for="(item,index) in dataArr" :key="index" class="carry-out-item">
        <div v-if="item.isEnforce">
          <Row class="item-header">
            <span>{{ item.applyForTime }}</span>
            <span>执行案号[ {{ item.caseNumber }} ]</span>
            <Tag style="border-radius:11px;" :color="getTagColor(item.enforceResult)">{{ item.enforceResult&&item.results.length!=0?item.results[0].enforceResultName:"暂无执行结果" }}</Tag>
            <Row class="btn-box">
              <span v-if="item.enforceResult && editState" type="text" @click="getDetail(item.id)">
                修改
                <i class="icon-edit-01"></i>
              </span>
              <span v-if="!item.enforceResult" type="text" @click="getDetail(item.id)">
                补充执行信息
                <i class="icon-increase-01"></i>
              </span>
            </Row>
          </Row>
          <Row class="item-content">
            <Row class="item-row">
              <span class="item-label">受理费用</span>
              <span class="item-text fee-text">{{ common.formateNumber(item.acceptFee || "") }}</span>
            </Row>
            <Row v-if="item.enforceResult=='SR'">
              <Row class="item-row">
                <span class="item-label">终止执行日期</span>
                <span class="item-text">{{ item.results[0]?item.results[0].terminationEnforceTime:"" }}</span>
              </Row>
              <Row class="item-row">
                <span class="item-label">终止执行原因</span>
                <span class="item-text">{{ item.results[0]?item.results[0].reason:"" }}</span>
              </Row>
            </Row>
            <Row v-if="item.enforceResult=='NP'">
              <Row class="item-row">
                <span class="item-label">未到款原因</span>
                <span class="item-text">{{ item.results[0]?item.results[0].reason:"" }}</span>
              </Row>
            </Row>
            <Row v-if="item.enforceResult=='AP'">
              <Row class="item-row">
                <span class="item-label">执行金额</span>
                <span class="item-text fee-text">{{ common.formateNumber(item.results[0]?item.results[0].amount:"") }}</span>
              </Row>
              <Row class="item-row">
                <span class="item-label">执行结果附件</span>
                <span class="item-text">
                  <file-upload
                    :size="50"
                    :default-list="item.results[0]?item.results[0].attachments:[]"
                    :upload-config="{readOnly:true}"
                  />
                </span>
              </Row>
            </Row>
            <Row class="item-row">
              <span class="item-label">申请执行附件</span>
              <span class="item-text">
                <file-upload
                  :size="50"
                  :default-list="item.attachments || []"
                  :upload-config="{readOnly:true}"
                />
              </span>
            </Row>
          </Row>
        </div>
        <div v-else>
          <Row class="item-header">
            <span>不需要执行</span>
          </Row>
        </div>
      </Row>
      <h3 v-if="dataArr.length==0" style="text-align:center;margin-top:10px;">暂无相关信息</h3>
    </Row> -->
    <Row class="case-content">
      <!-- 执行立案 -->
      <!-- <ExecutionFiling v-if="tabActive === 'executionFiling'" v-bind="$attrs" :case-id="caseId" :process-id="processId" @getAuditState="getState" v-on="$listeners" /> -->
      <ExecutionFiling v-if="tabActive === 'executionFiling'" v-bind="$attrs" :case-id="caseId" :process-id="processId" v-on="$listeners" />
      <!-- 受理 -->
      <Acceptance v-if="tabActive === 'acceptance'" v-bind="$attrs" :case-id="caseId" :process-id="processId" v-on="$listeners" />
    </Row>
    <!-- 新建/编辑执行 -->
    <!-- <Modal
      v-model="addCtrl"
      :title="activeData?'编辑执行':'新建执行'"
      width="600"
      :footer-hide="true"
    >
      <carry-out-form v-if="addCtrl" :default-data="activeData" :case-id="caseId" :process-id="processId" @changeEditCtrl="changeCtrl" v-on="$listeners" />
    </Modal> -->
  </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss'
// import carryOutForm from './carryOutForm.vue'
import ExecutionFiling from './components/ExecutionFiling.vue'
import Acceptance from './components/Acceptance.vue'
export default {
  components: {
    // carryOutForm,
    ExecutionFiling,
    Acceptance
  },
  props: ['caseId', 'processId', 'editState', 'caseState'],
  data () {
    return {
      tabActive: 'executionFiling',
      disabledCtrl: true,
      showOld: false,
      styles: styles,
      addCtrl: false,
      activeData: '',
      dataArr: []
    }
  },
  computed: {
    isCarryOut() {
      let bool = true
      this.dataArr.forEach((item, index) => {
        if (!item.isEnforce) {
          bool = false
          return
        }
      })
      return bool
    }
  },
  watch: {
    dataArr: {
      handler(nV, oV) {
        if (nV.length) {
          if (this.dataArr[0].deliveryTime) {
            this.showOld = false
          } else {
            this.showOld = true
          }
        }
      }
    }
  },
  created() {},
  beforeMount() {
    this.getData()
  },
  mounted() {},
  updated() {},
  methods: {
    getState(state) {
      this.disabledCtrl = !state
    },
    // 获取执行接口
    getData() {
      const url = '/business/case/enforces?processId=' + this.processId
      this.$get(url).then(res => {
        if (res.code === 0 && res.data) {
          this.dataArr = res.data
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    // 获取单条执行信息详情
    getDetail(id) {
      const url = '/business/case/enforce/' + id
      this.$get(url).then(res => {
        if (res.code === 0 && res.data) {
          this.activeData = res.data
          this.addCtrl = true
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    getTagColor(state) {
      if (!state) { return styles.labelColor }
      const colorObj = {
        'NP': styles.warningColor,
        'AP': styles.successColor,
        'SR': styles.errorColor
      }
      if (state) { return colorObj[state] }
    },
    openAdd() {
      this.activeData = ''
      this.addCtrl = true
    },
    changeCtrl(bool) {
      this.addCtrl = false
      if (bool) {
        this.getData()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../caseCommon.scss';
// @import "./carryOut.scss";
.carry-out{
    .case-content{
        margin-top: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/civilCase/carryOut/index.vue